<div class="error-400">
  <div class="container-fluid">
    <div class="row mb40">
      <div class="col-sm-12">
        <div class="text-center">
          <h2>{{ 'error.forbiddenForScheduler' | translate }}</h2>
        </div>
      </div>
    </div>
  </div>
</div>
